/* eslint-disable import/prefer-default-export */
enum NavNames {
  home = 'home',
  history = 'history',
  code = 'code',
  art = 'art',
  podcast = 'podcast',
  videos = 'videos',
}

interface NavItems {
  items: {
    [name in NavNames]: {
      name: string;
      'nav-name': string;
      id: number;
    };
  };
  order: string[];
}

export const NAV_ITEMS: NavItems = {
  items: {
    home: {
      name: 'Home',
      'nav-name': 'Home',
      id: 0,
    },
    history: {
      name: 'History',
      'nav-name': 'History',
      id: 1,
    },
    code: {
      name: 'Code',
      'nav-name': 'Code',
      id: 2,
    },
    art: {
      name: 'Art',
      'nav-name': 'Arts',
      id: 3,
    },
    podcast: {
      name: 'Podcast',
      'nav-name': 'Podcast',
      id: 4,
    },
    videos: {
      name: 'Videos',
      'nav-name': 'Videos',
      id: 5,
    },
  },
  order: ['home', 'history', 'code', 'art', 'podcast', 'videos'],
};

export const SOCIAL_LINKS = {
  github: 'https://github.com/sailor95',
  linkedIn: 'https://www.linkedin.com/in/david-huang-217561179/',
  medium: 'https://medium.com/sailor-spaceship',
};

export const THEME_LOCAL_STORAGE_KEY = 'theme';

export const THEMES = {
  dark: 'dark',
  light: 'light',
};
